/**
 * Feature flags de release.
 *
 * Não confundir com `partnerFeatureFlags.js` (white label / VUE_APP_PARTNER).
 *
 * Flag em `RELEASED_IN_ALL_ENVS` aparece em dev, staging e production.
 * Qualquer outra constante fica oculta.
 */

export const RELEASE_FEATURE = {
  HIDE_DUTY_VALUE_ON_SCHEDULE: 'HIDE_DUTY_VALUE_ON_SCHEDULE',
}

const RELEASED_IN_ALL_ENVS = new Set([
  RELEASE_FEATURE.HIDE_DUTY_VALUE_ON_SCHEDULE,
])

export function hasReleaseFeature (flag) {
  return RELEASED_IN_ALL_ENVS.has(flag)
}
